// Сина — active (v6): «1 раз за бой уничтожь своего юнита; нанеси Герою
// врага урон = атаке этого юнита».
//
// v6 dsl_active: target=ally_choose, effect=destroy_self_then_damage_hero,
// value=target_atk, uses=1.
//
// Цель: любой свой живой юнит на поле.
// Эффект:
//   1. Зафиксировать current.atk выбранного юнита.
//   2. Юнит уходит в обычную смерть — Посмертия + триггер Сины «+1 Влияния
//      за смерть своего юнита» срабатывают через onUnitDied.
//   3. Вражескому Герою — урон = зафиксированной атаке. Не пробивающий:
//      броня / Парашют / Иммунитет учитываются. Пробивает Авангард.
//
// До C.1 здесь была старая способность «посмотри 2 карты руки врага» —
// заменена на v6-вариант (БУГ.18).

import { applyHeroDamage } from '../../hero-damage.js';
import { onUnitDied } from './index.js';

export const HERO_ID = 'deus_sina';

// Свои живые юниты на поле.
export function getSinaActiveTargets(state, playerIdx) {
  return state.players[playerIdx].unitsOnField();
}

export function sinaActiveAvailable(state, playerIdx) {
  const p = state.players[playerIdx];
  if (!p || p.hero.id !== HERO_ID) return false;
  if (p.heroActiveUsed) return false;
  if (p.hero.hp <= 0) return false;
  if (getSinaActiveTargets(state, playerIdx).length === 0) return false;
  return true;
}

// Возвращает {ok, dmg, killed?} либо {ok:false, reason}.
export function sinaActive(state, playerIdx, targetCard) {
  if (!sinaActiveAvailable(state, playerIdx)) {
    return { ok: false, reason: 'unavailable' };
  }
  if (!targetCard || targetCard.type !== 'unit' || !targetCard.isAlive()) {
    return { ok: false, reason: 'invalid_target' };
  }
  const me = state.players[playerIdx];
  if (targetCard.ownerId !== me.id) {
    return { ok: false, reason: 'not_ally' };
  }
  if (!me.unitsOnField().includes(targetCard)) {
    return { ok: false, reason: 'not_on_field' };
  }
  const enemy = state.players[1 - playerIdx];
  // 1) Зафиксировать атаку уничтожаемого юнита.
  const dmg = targetCard.current.atk;
  state.log.add(
    `✨ Сина [${me.name}] [active]: уничтожает ${targetCard.name_ru} (atk ${dmg}) → удар по Герою [${enemy.name}]`
  );
  // 2) Юнит уходит в обычную смерть — Посмертия + триггер Сины «+1 Влияния».
  targetCard.alive = false;
  me.removeFromField(targetCard);
  state.log.add(`✗ ${targetCard.name_ru} [${me.name}] уничтожен (Сина active)`);
  onUnitDied(state, {
    ownerIdx: playerIdx, card: targetCard,
    killer: null, killerIdx: null, killerWasCounter: false
  });
  // 3) Урон Герою врага = atk юнита. Не пробивающий, через applyHeroDamage.
  const r = applyHeroDamage(state, 1 - playerIdx, dmg, { pierce: false });
  if (!r.immune && !r.parachute) {
    state.log.add(
      `⚔ Сина [active] → ${enemy.hero.name_ru} [${enemy.name}]: ${dmg} урона ` +
      `(HP ${enemy.hero.current.hp + (r.hpLost || 0)}→${enemy.hero.current.hp}, ` +
      `броня ${enemy.hero.current.armor + (r.armorAbsorbed || 0)}→${enemy.hero.current.armor})`
    );
  }
  me.heroActiveUsed = true;
  return { ok: true, dmg, killed: enemy.hero.current.hp <= 0 };
}
